export enum Currency {
  PLN = 'PLN',
  EUR = 'EUR',
  GBP = 'GBP',
  USD = 'USD',
  AUD = 'AUD',
  CAD = 'CAD',
  HKD = 'HKD',
  SGD = 'SGD',
  CZK = 'CZK',
  BRL = 'BRL',
  MXN = 'MXN',
  DKK = 'DKK',
  NOK = 'NOK',
  SEK = 'SEK',
  NZD = 'NZD',
  JPY = 'JPY'
}

export const CurrencySymbol: Record<Currency, string> = {
  [Currency.PLN]: 'zł',
  [Currency.EUR]: '€',
  [Currency.GBP]: '£',
  [Currency.USD]: '$',
  [Currency.AUD]: '$',
  [Currency.CAD]: '$',
  [Currency.HKD]: '$',
  [Currency.SGD]: '$',
  [Currency.CZK]: 'Kč',
  [Currency.BRL]: 'R$',
  [Currency.MXN]: '$',
  [Currency.DKK]: 'Kr.',
  [Currency.NOK]: 'kr',
  [Currency.SEK]: 'kr',
  [Currency.NZD]: '$',
  [Currency.JPY]: '¥'
}
